import { EntityWithUser } from "../../types/entity";
import {
    FinancialAccount,
    FinancialAccountBase,
} from "../../types/financialAccount";
import { EntityDto, EntityWithUserDto } from "../entity/entity.dto";
import { FinancialAccountDto } from "../financialAccount/financial-account.dto";

/**
 * Base type for EntityContext - uses base types.
 * Used by controllers and services before relation validation.
 * Requires entity.user to be loaded for EntityWithUserDto.
 */
export interface EntityContextBase {
    entity: EntityWithUser;
    financialAccounts: FinancialAccountBase[];
    mockEntityIncludesTransactions?: boolean;
}

/**
 * Strict type for EntityContext - requires loaded relations.
 * Used by DTOs and service boundaries after relations are loaded.
 */
export interface EntityContext {
    entity: EntityWithUser;
    financialAccounts: FinancialAccount[];
    mockEntityIncludesTransactions?: boolean;
}

export class EntityContextDto {
    static deserialize(dto: EntityContextDto): EntityContext {
        return {
            ...dto,
            entity: EntityDto.deserialize(dto.entity) as EntityWithUser,
            financialAccounts: dto.financialAccounts.map(
                FinancialAccountDto.deserialize,
            ),
        };
    }

    entity: EntityDto;
    financialAccounts: FinancialAccountDto[];
    mockEntityIncludesTransactions?: boolean;

    constructor(context: EntityContextBase) {
        this.entity = new EntityWithUserDto(context.entity);
        this.financialAccounts = context.financialAccounts.map(
            (fa) => new FinancialAccountDto(fa),
        );
        this.mockEntityIncludesTransactions =
            context.mockEntityIncludesTransactions;
    }
}
